import { useCreate } from '@refinedev/core'
import { App, Breadcrumb, Button, Card, Form, Input } from 'antd'
import { Link, useNavigate } from 'react-router-dom'

export default function UserGroupCreatePage() {
  const [form] = Form.useForm()
  const { modal } = App.useApp()
  const { mutateAsync: create, mutation } = useCreate()
  const navigate = useNavigate()

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      void modal.confirm({
        title: 'Create user group',
        content: `Create user group "${values.name}"?`,
        okText: 'Create Group',
        onOk: () =>
          create({ resource: 'user-groups', values }).then(
            () => navigate('/user-groups'),
            // Refine's error notification already reports the failure
            () => undefined,
          ),
      })
    } catch {
      // validation error
    }
  }

  return (
    <div>
      <Breadcrumb
        style={{ marginBottom: 16 }}
        items={[
          {
            title: <Link to="/user-groups">User Groups</Link>,
          },
          { title: 'Create' },
        ]}
      />
      <h2 style={{ marginBottom: 24 }}>Create User Group</h2>
      <Card style={{ maxWidth: 600 }}>
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Group Name"
            rules={[
              {
                required: true,
                message: 'Name is required',
              },
            ]}
          >
            <Input placeholder="Enter group name" />
          </Form.Item>
          <Form.Item name="description" label="Description">
            <Input.TextArea placeholder="Optional description" rows={3} />
          </Form.Item>
          <Button
            type="primary"
            onClick={handleSubmit}
            loading={mutation.isPending}
          >
            Create Group
          </Button>
        </Form>
      </Card>
    </div>
  )
}
